// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2SgsS","modalFooterButton":"ModalNotes_modalFooterButton__327Lq"};